/**
 * 紫微 12 宮極簡圓環。
 *
 * 4x4 格子，12 個邊框格放 12 宮，中間 2x2 留空標「紫微」。
 *
 *  ┌──┬──┬──┬──┐
 *  │父│命│兄│夫│
 *  ├──┼──┴──┼──┤
 *  │福│       │子│
 *  ├──┤ 紫微 ├──┤
 *  │田│       │財│
 *  ├──┼──┬──┼──┤
 *  │官│奴│遷│疾│
 *  └──┴──┴──┴──┘
 *
 * 佔位版——真命盤之後串 worker-astro。
 */

// 依 4x4 row-major 顯示順序排的 12 宮（中間 2x2 是 null）
// row 0: 父母 命宮 兄弟 夫妻
// row 1: 福德  -    -    子女
// row 2: 田宅  -    -    財帛
// row 3: 官祿 奴僕 遷移 疾厄
const LAYOUT: readonly (string | null)[] = [
  '父母', '命宮', '兄弟', '夫妻',
  '福德', null, null, '子女',
  '田宅', null, null, '財帛',
  '官祿', '奴僕', '遷移', '疾厄',
] as const;

interface ZiweiMiniChartProps {
  mainPalace?: string; // 命宮（高亮用）
}

export function ZiweiMiniChart({ mainPalace = '命宮' }: ZiweiMiniChartProps) {
  return (
    <div className="rounded-lg border border-paper bg-cream/60 p-3">
      <h3 className="mb-2 text-xs font-medium text-ink/60">紫微</h3>
      <div
        className="relative grid aspect-square grid-cols-4 grid-rows-4 gap-0.5"
      >
        {LAYOUT.map((palace, idx) =>
          palace ? (
            <div
              key={`${idx}-${palace}`}
              className={`flex items-center justify-center border text-[10px] ${
                palace === mainPalace
                  ? 'border-accent bg-accent/10 font-bold text-accent'
                  : 'border-ink/10 text-ink/70'
              }`}
            >
              {palace}
            </div>
          ) : (
            <div key={`blank-${idx}`} />
          ),
        )}
        {/* 中間 2x2 疊一張「紫微」卡 */}
        <div
          className="pointer-events-none absolute inset-0 flex items-center justify-center"
          aria-hidden
        >
          <div className="flex h-1/2 w-1/2 items-center justify-center border border-ink/5 bg-cream font-serif text-xs text-ink/50">
            紫微
          </div>
        </div>
      </div>
    </div>
  );
}
